import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { DropdownModule } from "primeng/dropdown";



import { BigMailChimpFormComponent } from "./big-mailchimp-form.component";

@NgModule({
  declarations: [
    BigMailChimpFormComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    DropdownModule,
  ],
  exports:[BigMailChimpFormComponent],
  providers: [],
  bootstrap: [],
})
export class BigMailChimpFormModule {}
